// core
import React from "react";

// styles
import styles from "./Header.module.scss";
import cx from "classnames";

const Header: React.FC = (props) => {
    return (
        <header className={cx([styles.header, "layout-flex-column"])}>
            {props.children}
        </header>
    );
};

export default Header;
